
import Vue from 'vue';
import {Toast} from 'vant'
import channels from '../constant/channels'
import {sendOrder, getOpenid} from '../api/getData'
import {isIphone, isIpad, isWeiXin, isApp, isAndroid, isOTT, getInvoker, getPlatform,isSupportsWebP} from '../tools/mgtv/env'
import { OPENID, WX_OPEN_ID } from '../constant/CookieKeys';
import { getStore, setStore } from './mUtils';
import { orderEvent } from '../tools/mgtv/analysis';
import * as Cookie from 'tiny-cookie'
let domain = "testclub.bz.mgtv.com"; //正式地址：club.mgtv.com
Vue.use(Toast)
const channel_name = {
  '9D5A10B33BCD': 'alipay',
  'ZFB34XYB49X6': 'alipaysdk',
  'QA3R2TD56U12': 'alipay',
  '837D14E0B693': 'wechat',
  '1DF81F20CD7M': 'wechat',
  '2BU45R97JD7A': 'wechat',
  'J3C03EC0249B': 'jdpay',
  'C127CA0D4C66': 'ccbpay',
  'EF5C7535A51M': 'cmbpay',
  'SCENE535A51M': 'cmbpay'
};
function getChannel(){
  let channel;
  if(!isApp()){
     channel = isWeiXin()?channels.wechat.js:channels.alipay.js 
  }
  else{
      channel = channels.wechat.app      
  }
  return channel;
}
function  order($vm,op,openId_pay,pay_success){  
    const deviceInfo= $vm.deviceInfo      
    const clocation ="1"   
    op.channel = getChannel()
    if(isWeiXin())
    {
        op.openid = openId_pay 
        op.returnUrl = ""
    }
    else{
        op.openid = ""
        op.returnUrl = encodeURIComponent("http://testclub.bz.mgtv.com/#/OrderSuccess?vconsole=show");
    }
    if(!op.voucherid)
    {
        op.voucherid = ""
    }
    console.log("ticket:",op.ticket)
    console.log("openid:",op.openid)
    console.log("channel:",op.channel)
    if(!/^1\d{10}$/.test(op.phone))
    {   
        Toast("手机号码不正确！")
        return
    }
    //保存收货地址
    sendOrder(op.ticket,op.productId,op.openid,op.channel,op.address,op.phone,op.receiverName,op.voucherid,op.returnUrl,op.mac).then(res => {              
        if(res && res.err==0){
                console.log('下单成功a');            
                let productInfo ={
                    productId :op.productId
                }
                
                // click_event('下单成功(总)',$vm);
                // click_event('下单成功(' + window.gact.platform + '-' + deviceInfo.appVersion + ')',$vm);                
                setTimeout(()=>{
                    continuePay(res,productInfo,pay_success,$vm);
                },300)
                orderEvent(clocation, productInfo.productId, res.data.order_price, res.data.channel, res.data.order_id,$vm);
        }
        else{
                // click_event('下单失败(总)',$vm);
                // click_event('下单失败(' + window.gact.platform + '-' + deviceInfo.appVersion + ')',$vm);
                if(res.code=="01"){
                    window.$dialog.alert({
                        message: '登录信息已过期，请重新登录'
                    }).then(() => {
                        if (window.gact.is_h5) {
                            logout()
                        }
                    });
                }
                else{
                    Toast("系统繁忙，请稍后再试");
                }
        }
    }).catch(error=>{
        console.log("reject",error)
    })
}
let wx = {
  ready: function (callback) {
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', callback, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', callback);
        document.attachEvent('onWeixinJSBridgeReady', callback);
      }
    } else {
      callback();
    }
  },
  pay: function (obj, success, fail) {
    try {
      this.ready(function () {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": obj.appId, //公众号名称，由商户传入
            "timeStamp": obj.timeStamp, //时间戳，自1970年以来的秒数
            "nonceStr": obj.nonceStr, //随机串
            "package": obj.package,
            "signType": obj.signType, //微信签名方式：
            "paySign": obj.paySign //微信签名
          },
          function (res) {
            console.log("微信支付返回：",res.err_msg)
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              if (success) success("购买成功");
            } else {
              if (fail) fail("购买失败");
            }
          }
        );
      })
    } catch (ex) {
      alert(ex)
    }
  },
//   requestOpenId: function (code, success) {
//     // success && success("testopenId_pay");//调式语句
//     // loading = Toast.loading({
//     //   mask: true,
//     //   message: '加载中...'
//     // });
//     ajax("get", interfaceURI + "/v2/mangoLogin/baseInfo/" + code, null, function (data) {
//         // loading.clear();
//         if (data && data.err == 0) {
//           var udata = typeof data.data == "string" ? JSON.parse(data.data) : data
//             .data;
//           if (udata.openid) {
//             openId_pay = udata.openid;
//             success && success(openId_pay);
//           }
//         }
//          else
//             console.log("获取openId失败")
//       }, "json")
//       .error(function (xhr, textStatus, errorThrown) {
//         // loading.clear();
//         console.log("获取openId失败")
//       });
//   },
  oauth: function () {
    var scope = "snsapi_base"; //"snsapi_userinfo"
    var isOnline = document.domain == "club.mgtv.com";
    var appId = isOnline ? "wxcb4da5d4124683f0" : "wx472419be75be788c";
    // oauthUri = addUrlParams(
    //   'https://open.weixin.qq.com/connect/oauth2/authorize#wechat_redirect', {
    //     // oauthUri = addUrlParams('authorize.html#wechat_redirect', {//调式语句
    //     'appid': appId,
    //     'redirect_uri': encodeURIComponent(location.href),
    //     'response_type': 'code',
    //     'scope': scope,
    //     'state': "State"
    //   });
    console.log("document.URL",document.URL)
    console.log("location.href",location.href)
    let  oauthUri ='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appId+ "&response_type=code&scope="+scope+"&state=State&redirect_uri="+ encodeURIComponent(location.href)+"#wechat_redirect"
    console.log(oauthUri)
    
    window.location = oauthUri;
  },
  closeWindow: function () {
    this.ready(function () {
      WeixinJSBridge.call('closeWindow');
    })
  },
  hideOptionMenu: function () {
    this.ready(function () {
      WeixinJSBridge.call('hideOptionMenu');
    })
  }

}
let ali = {
    pay: function (url) {
        window.location = url
    }
}
let mgapp={
    pay:function(res,product,success,fail,source){ 
        console.log("app.pay")  
        let clocation = "1"      
        let productInfo = {}
        productInfo.product_id = product.productId
        productInfo.price = res.data.order_price

        const iapParams = JSON.stringify({
            // 这个是活动统计那边的，有就传，没就留空
            pagename: 'ACT_D',
            actid: source,
            clocation: clocation,
            p: productInfo.product_id, // 产品包id
            pp: productInfo.price, // 价格
            c: res.data.channel, // 渠道号
            o: res.data.order_id, // 支付订单id,这里为了避免出现结果页使用的以noas-开头的业务订单
            videoId: '',
            iapType: '',
            payUrl: res.data.pay_type === 'location' ? res.data.pay_msg : '',
            sdkData: res.data.pay_type === 'result' ? res.data.pay_msg : '',
            t: channel_name[res.data.channel],
            completed_url: res.data.completed_url
          });
        console.log("iapParams",iapParams)
        MgtvApi.getIap(iapParams);//唤起支付
    }
}
function paySuccess(){
  console.log("支付成功")
    Toast("支付成功")
}
function payFail(obj){
    console.log("支付失败")
    console.log("obj",obj)
    Toast("支付失败")
}
function continuePay(res,productInfo,pay_success,$vm) {
    const source = $vm.urlParams?$vm.urlParams.source:gact.source
    
    if (res && res.err == 0) {
        console.log(res.data)
        let payType = res.data.pay_type
        let channel = res.data.channel
        let pay_data = ""
        if (payType == "location") {
            pay_data = res.data.pay_msg //payType=="location",url为uri格式，payType=="qrcode",url为json字符串
        } else if (payType == "qrcode") {
            pay_data = JSON.parse(res.data.pay_msg) //payType=="location",url为uri格式，payType=="qrcode",url为json字符串
        } else {
            Toast("result支付")                        
            pay_data = res.data.pay_msg
        }
        
        if(isApp()){
            console.log("isApp")
            if(isAndroid()){//安卓APP
                console.log("isAndroid")
                mgapp.pay(res,productInfo,paySuccess,payFail,source)
            }
            else{//苹果APP
                Toast("苹果APP不支持购买")
            }
        }
        else{
            console.log("非app")
            if(isWeiXin())//微信浏览器
            {
                console.log("isWeiXin")
                wx.pay(pay_data, pay_success, payFail)
            }
            else{//普通浏览器
                console.log("isBroswer")
                ali.pay(pay_data, paySuccess, payFail)
            }
        }
    } else {
        payFail()
    }
}


export function requestOpenId(code,cb){
    if (isWeiXin()) { //微信环境
        console.log("orderAndPay_isWeiXin")
        // wx.hideOptionMenu(); //隐藏右上角三个点按钮。
        let openId_pay = getStore(OPENID)        
        if(!openId_pay){
          if (!code) {
              console.log("微信授权即将跳转")
              wx.oauth() //微信授权
          } else {
              console.log("用户认证中:" + code)
            //   alert("用户认证中:" + code)
              getOpenid(code).then(data=>{
                    console.log("getOpenid data",data)
                    if (data && data.err == 0) {
                        var udata = typeof data.data == "string" ? JSON.parse(data.data) : data.data;
                        if (udata.openid) {
                            openId_pay = udata.openid;
                            // alert("openId_pay:"+openId_pay)
                            setStore(OPENID,openId_pay)
                            cb&&cb()
                        }
                        else{
                            console.log("获取openId失败")
                        }
                    }
                    else
                        console.log("获取openId失败")
              })
              .catch(error=>{
                console.log("getOpenid",error)
              })
          }
        }
        else{
            cb&&cb()
        }
    }
}
export function wxOauth(code){
    if (isWeiXin()) { //微信环境
        console.log("orderAndPay_isWeiXin")
        let openId_pay = getStore(OPENID)
        if(!openId_pay){
          if (!code) {
              console.log("微信授权即将跳转")
              wx.oauth() //微信授权
          } 
          else{
              console.log("授权code"+code)
              setCookie
          }
        }
        else{
            console.log("公众号openid"+openId_pay)
        }
    }
}
export default function orderAndPay(order_params,code,pay_success,$vm){
    if (isWeiXin()) { //微信环境
        const openId_pay = getStore(OPENID)
        console.log("orderAndPay openId_pay",openId_pay)
        if(openId_pay)
        {
            order($vm,order_params,openId_pay,pay_success) //下单
        }
        else{
            let code = $vm.urlParams.code
            requestOpenId(code,()=>{
                order($vm,order_params,openId_pay,pay_success)
            })
        }
    } else {
        console.log("正在下单") //调式语句
        order($vm,order_params)
    }
};

export {wx,ali,getChannel}



// WEBPACK FOOTER //
// ./src/api/pay.js